import apiClient from './client';
export interface StaffingUser {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    roles: {
        name: string;
    }[];
    qualifiedRoleIds: number[];
    lastAssessedDate: string | null;
}
export const staffingService = {
    list: async (assessmentId?: number): Promise<{
        data: StaffingUser[];
    }> => (await apiClient.get('/assessments/staffing', { params: { assessmentId } })).data,
    save: async (userId: number, roleIds: number[]) => (await apiClient.put(`/assessments/staffing/${userId}/qualifications`, { roleIds })).data,
    roles: async (): Promise<{
        data: any[];
    }> => (await apiClient.get('/assessments/roles')).data,
    candidates: async (): Promise<{
        data: any[];
    }> => (await apiClient.get('/assessments/staffing-candidates')).data,
    updateEvent: async (id: number, data: any) => (await apiClient.patch(`/assessments/${id}`, data)).data,
};
